import 'whatwg-fetch';
import { api, jsonData } from 'config';
import PromotionFactory from "factories/Promotion";
import ListService from "services/AccountLists/";
import ProductFactory from "factories/Products";
import SalesChannel from 'services/SalesChannel'
import StorageService from 'services/StorageService'

let cacheObject = {
    result: {
        categories: null,
        promotions: null,
    },
    promise: {
        categories: null,
        promotions: null
    }
};

let controllersRequest = {
    searchProducts: null,
    searchCategories: null
};

let attemptAtService = {
    product: 0,
    products: 0,
    productsByUrl: 0,
    search: 0,
    searchCategoties: 0,
    categories: 0,
    specification: 0,
    promotions: 0,
    categorySpecifications: 0,
    filters: 0
};

const get = (slug) => {
    const salesChannel = SalesChannel.getSalesChannel();

    if (typeof window !== 'undefined' && window.__renderData && window.__renderData.pdp && window.__renderData.pdp.product) {
        return new Promise(resolve => {
            const data = window.__renderData.pdp.product;
            delete window.__renderData.pdp.product;
            resolve(data);
        });
    }
    return fetch(api.catalog + `/catalog_system/pub/products/search/${slug}/p?sc=${salesChannel}`, {
        headers: {
            'x-api-key': api.apiKey
        }
    })
        .then(results => results.json())
        .then(results => _validationError('product', () => get(slug), results))
        .catch(() => _validationError('product', () => get(slug)));
}

const _validationError = (name, callback, results = null) => {
    if (!(results && !(results.status && results.message))) {
        return _productsError(name, callback);
    }

    attemptAtService[name] = 0;
    return results;
}

const getByURl = (url, version = 1) => {
    const salesChannel = SalesChannel.getSalesChannel();

    const newUrl = `${url}${url.indexOf('?') === -1 ? '?' : '&'}sc=${salesChannel}`;

    if (typeof window !== 'undefined' && window.__renderData && window.__renderData.plp && window.__renderData.plp.plp_products && window.__renderData.plp.plp_products.data && window.__renderData.plp.plp_products.data.length) {

        return new Promise(resolve => {
            const data = window.__renderData.plp.plp_products;
            delete window.__renderData.plp.plp_products;

            resolve(data);
        });
    } else if (typeof window !== 'undefined' && window.__renderData && window.__renderData.products && window.__renderData.products[newUrl]) {

        return new Promise(resolve => {

            const data = window.__renderData.products[newUrl];
            delete window.__renderData.products[newUrl];

            resolve(data);
        });
    }

    const prefixUrl = version === 1 ? api.catalog : api.catalogV2;

    return fetch(prefixUrl + `/products/search${newUrl}`, {
        headers: {
            'x-api-key': api.apiKey
        }
    })
        .then(results => _returnProducts('productsByUrl', () => getByURl(url), results))
        .catch(err => {
            console.log(err);
            return false;
        })
        //.catch(() => _returnProducts('productsByUrl', () => getByURl(url)));
}

const _returnProducts = (name, callback, results = null) => {
    if (!results) {
        return _productsError(name, callback);
    }

    const resources = results.headers.get('resources');

    return results.json().then(response => {
        if (!(response && !(response.status && (response.message || response.mensage)))) {
            return _productsError(name, callback);
        }

        attemptAtService[name] = 0;

        return {
            data: response,
            resources: resources
        };
    });
}

const _productsError = (name, callback) => {
    attemptAtService[name] = attemptAtService[name] + 1;

    if (attemptAtService[name] > 3) {
        attemptAtService[name] = 0;
        return false;
    } else {
        return callback();
    }
}

const getFilters = (url) =>{
    const salesChannel = SalesChannel.getSalesChannel();
    const newUrl = `${url}${url.indexOf('?') === -1 ? '?' : '&'}sc=${salesChannel}`;

    if (typeof window !== 'undefined' && window.__renderData && window.__renderData.plp && window.__renderData.plp.filters) {
        return new Promise(resolve => {
            const filters = window.__renderData.plp.filters;
            delete window.__renderData.plp.filters;
            resolve(filters);
        });
    }

    return fetch(api.catalog + `/facets/search${newUrl}`, {
        headers: {
            'x-api-key': api.apiKey
        }
    }).then(results => _getDataHeader('url-decode', results))

        .then(results => _validationError('filters', () => getFilters(url), results))
        .catch(() => _validationError('filters', () => getFilters(url)));
}

const _getDataHeader = (name, result) => {
    const param = result.headers.get(name);

    return result.json().then(data => {
        if(param) {
            data[name] = param;
        }

        return data;
    })
}

const getCategorySpecifications = (categoryId) => {
    return fetch(api.catalog + `/catalog_system/pub/specification/field/listByCategoryId/${categoryId}`, {
        headers: {
            'x-api-key': api.apiKey
        }
    }).then(results => results.json())
        .then(results => _validationError('categorySpecifications', () => getCategorySpecifications(categoryId), results))
        .catch(() => _validationError('categorySpecifications', () => getCategorySpecifications(categoryId)));
}

const getCategories = () => {
    if (cacheObject.result.categories) {
        return Promise.resolve(cacheObject.result.categories);
    }
    if (typeof window !== 'undefined' && window.__renderData && window.__renderData.categories) {
        return new Promise(resolve => {
            cacheObject.result.categories = window.__renderData.categories;
            const categories = window.__renderData.categories;
            delete window.__renderData.categories;
            resolve(categories);
        });
    }

    if (!cacheObject.promise.categories) {
        cacheObject.promise.categories = fetch(jsonData.categories, {
            headers: {
                'x-api-key': api.apiKey,
                'pragma': 'no-cache',
                'cache-control': 'no-cache'
            }
        }).then(results => results.json())
            .then(results => _validationError('categories', () => {
                cacheObject.promise.categories = null;
                return getCategories();
            }, results))
            .then(results => {
                cacheObject.result.categories = results;
                cacheObject.promise.categories = null;
                return results;
            })
            .catch(() => _validationError('categories', () => {
                cacheObject.promise.categories = null;
                return getCategories();
            }));
    }

    return cacheObject.promise.categories;
}


const getPromotions = () => {
    if (cacheObject.result.promotions) {
        return Promise.resolve(cacheObject.result.promotions);
    }

    if (typeof window !== 'undefined' && window.__renderData && window.__renderData.promotions) {
        const promotions = window.__renderData.promotions;
        delete window.__renderData.promotions;
        cacheObject.result.promotions = promotions;
        return Promise.resolve(promotions);
    }

    if (!cacheObject.promise.promotions) {
        cacheObject.promise.promotions = fetch(jsonData.promotions, {
            headers: {
                'x-api-key': api.apiKey,
                'pragma': 'no-cache',
                'cache-control': 'no-cache'
            }
        }).then(results => results.json())
            .then(results => _validationError('promotions', () => {
                cacheObject.promise.promotions = null;
                return getPromotions();
            }, results))
            .then(results => {
                cacheObject.result.promotions = results;
                cacheObject.promise.promotions = null;
                return results;
            })
            .catch(() => _validationError('promotions', () => {
                cacheObject.promise.promotions = null;
                return getPromotions();
            }));
    }

    return cacheObject.promise.promotions;
}

const getOrderFormProducts = (orderForm) => {
    return new Promise((resolve, reject) => {
        let isTcenco = false;

        if(!(orderForm && orderForm.items && orderForm.items.length > 0)) resolve(orderForm);

        getPromotions().then(objectPromotions => {
            orderForm.items = orderForm.items.map((item) => {
                if(item.quantity===0) return false;
                PromotionFactory.setItemPromotions(item, objectPromotions);

                if (item.promotions && item.promotions.length > 0) {

                    item.promotions = PromotionFactory.create(item, { unit_multiplier: item.unitMultiplier });

                    const promotionsTcenco = item.promotions.filter(promotion => promotion.tcenco);

                    if ((promotionsTcenco.length > 0)) {
                        const minQuantity = promotionsTcenco[0].minQuantity || 1;

                        if (item.quantity >= minQuantity) {
                            let totalSellingPriceTcenco = parseInt(item.quantity / minQuantity) * (promotionsTcenco[0].price * 100) + ((item.quantity % minQuantity) * item.listPrice);
                            item.sellingPriceTcenco = totalSellingPriceTcenco / item.quantity;
                        }
                        isTcenco = true;
                    }
                }

                if (!item.sellingPriceTcenco) {
                    item.sellingPriceTcenco = item.sellingPrice;
                }

                return item;
            }).filter(Boolean);

            let subTotalTcenco = 0;

            const subtotal = _getValueTotalizer(orderForm.totalizers, 'Items');

            if (isTcenco) {
                subTotalTcenco = orderForm.items.reduce((lastValue, item) => {
                    return lastValue + (item.sellingPriceTcenco * item.quantity);
                }, 0);
            } else {
                const discounts = _getValueTotalizer(orderForm.totalizers, "Discounts");
                subTotalTcenco = (discounts ? discounts : 0) + subtotal;
            }

            orderForm.totalizers.push({
                id: 'Tcenco',
                name: 'Total de T. Cenco',
                value: subTotalTcenco
            });

            orderForm.totalizers.push({
                id: 'DiscountsTcenco',
                name: 'Total de descuentos T. Cenco',
                value: (subtotal - subTotalTcenco) * -1
            });

            resolve(orderForm);

        }).catch(error => {
            reject(error);
        });
    });
}

const factoryOrderFormProducts = (orderForm) => {
    return new Promise((resolve) => {
        let items = orderForm.items && orderForm.items[0] ? orderForm.items : [];

        if (typeof window !== 'undefined') {
            window.orderItems = {};

            items.map(item => {
                const quantity = items.filter(current => item.id === current.id).filter(Boolean).reduce((prevVal, elem) => {
                    return prevVal + elem.quantity
                }, 0);

                item.quantityTotal = quantity;

                window.orderItems[item.id] = {
                    quantity: item.quantity + (window.orderItems[item.id] ? window.orderItems[item.id].quantity : 0)
                };
                return item;

            });
        }

        let skus = [];

        items.map(item => {
            skus[item.id] = {quantity: 1};
            return item;

        });

        const updateCartItems = (results) => {
            if(results){
                results = results.map(product => {
                    return ProductFactory.create(product);
                });

                items.map(item => {
                    const product = results.filter(res => res.productId === item.productId);

                    if(product[0]){
                        item.maxItems = product[0].items[0].maxItems;
                        item.productClusters = product[0].productClusters;
                    }
                });
            } else {
                items.map(item => {
                    item.maxItems = 10;
                });
            }

            orderForm.items = items;

            resolve(orderForm);
        };

        if (items.length > 0) {
            if (skus.length > 0) {
                ListService.productsSkus(skus).then(results => updateCartItems(results));
            } else {
                updateCartItems([]);
            }
        } else {
            resolve(orderForm);
        }
    });
}

const _getValueTotalizer = (totalizers, id) => {
    const items = totalizers.filter(item => item.id === id);
    return items[0] ? items[0].value : 0;
}

const getSearchProducts = (search) => {
    if (controllersRequest.searchProducts) {
        controllersRequest.searchProducts.abort();
        controllersRequest.searchProducts = null;
    }

    let reqOptions = {
        headers: {
            'x-api-key': api.apiKey
        }
    };

    if (typeof window !== 'undefined' && window.AbortController) {
        controllersRequest.searchProducts = new AbortController();
        reqOptions.signal = controllersRequest.searchProducts.signal;
    }

    const salesChannel = SalesChannel.getSalesChannel();

    return fetch(api.catalog + `/catalog_system/pub/products/search/?ft=` + search + '&_from=0&_to=2&sc=' + salesChannel, reqOptions).then(results => results.json())
        .then(product => _validationError('search', () => getSearchProducts(search), product))
        .then(product => {
            controllersRequest.searchProducts = null;
            return product;
        })
        .catch((error) => {
            controllersRequest.searchProducts = null;
            if(error.toString() === 'AbortError: The user aborted a request.') return false;
            return _validationError('search', () => getSearchProducts(search))
        });
}

const getSearchCategories = (search) => {
    if (controllersRequest.searchCategories) {
        controllersRequest.searchCategories.abort();
        controllersRequest.searchCategories = null;
    }

    let reqOptions = {
        headers: {
            'x-api-key': api.apiKey
        }
    };

    if (typeof window !== 'undefined' && window.AbortController) {
        controllersRequest.searchCategories = new AbortController();
        reqOptions.signal = controllersRequest.searchCategories.signal;
    }

    return fetch(api.catalog + '/buscaautocomplete/?maxRows=12&productNameContains=' + search + '&suggestionsStack=', reqOptions)
        .then(results => results.json())
        .then(product => _validationError('searchCategoties', () => getSearchCategories(search), product))
        .then(categories => {
            controllersRequest.searchCategories = null;
            return categories
        })
        .catch((err) => {
            controllersRequest.searchCategories = null;
            if(err.toString() === 'AbortError: The user aborted a request.') return false;
            return _validationError('searchCategoties', () => getSearchCategories(search))
        });
}

const getFrequentProducts = (quantity) => {
    const salesChannel = SalesChannel.getSalesChannel();
    const token = StorageService.getItem('sessionData');

    return fetch(api.catalog + `/products/frequent?sc=${salesChannel}&qty=${quantity ? quantity : 36}`, {
        headers: {
            'x-api-key': api.apiKey,
            token
        }
    })
        .then(results => results.json());
}

const ProductService = {
    get,
    getPromotions,
    getSearchCategories,
    getByURl,
    getFilters,
    getCategorySpecifications,
    getOrderFormProducts,
    factoryOrderFormProducts,
    getSearchProducts,
    getCategories,
    getFrequentProducts

}

export default ProductService;
